import SingleToolSimilar from '@quicktools/shared-components/components/common/SingleToolSimilar/SingleToolSimilar';
import {
  SOCIAL_MEDIA_BIO_TOOL,
  AD_COPY_GENERATOR_TOOL,
  MARKETING_SLOGAN_TOOL,
  EMOJIS_TOOL,
  ToolCategory,
} from '@quicktools/shared-components/data/tools';
import { useTranslation } from 'react-i18next';

import analytics from '../../services/analytics';

const SIMILAR_TOOLS = [SOCIAL_MEDIA_BIO_TOOL, AD_COPY_GENERATOR_TOOL, MARKETING_SLOGAN_TOOL];

export default function SimilarTools() {
  const { t } = useTranslation();

  return (
    <SingleToolSimilar
      current={EMOJIS_TOOL}
      analytics={analytics}
      similar={SIMILAR_TOOLS}
      paragraph={t('landing.similarTools.paragraph')}
      category={ToolCategory.Text}
    />
  );
}
